import React, { useContext } from 'react';
import IpAllocationTable from './IpAllocationTable';
import AddIpAllocation from './AddIpAllocation';
import CustomPagination from '../../../../shared/CustomPagination';
import AppContext from '../../../../../../context/shared/AppContext';

const IpAllocationBody = () => {
  const { loading, paginateChange, pages } = useContext(AppContext);
  const pageChange = (params) => {
    const { selected } = params;
    paginateChange(selected + 1);
  };
  return (
    <div className="container">
      <div className="row mt-5">
        {/* <SearchCnMaestro /> */}
        <div className="form-group ml-2">
          <button className="btn btn-green" type="button" data-toggle="modal" data-target="#add-access-point">
            Add IP Allocation
          </button>
        </div>
        <AddIpAllocation />
        <IpAllocationTable />
        {!loading && (
          <CustomPagination
            pagesCount={pages}
            marginPagesDisplayed={5}
            pageRangeDisplayed={5}
            onPageChange={pageChange}
          />
        )}
      </div>
    </div>
  );
};

export default IpAllocationBody;
